import { useEffect } from 'react';

import { clarity } from 'react-microsoft-clarity';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

import { getJsonFromStorage } from 'helpers/localStorageHelper';

import { sendAnalyticEvent } from 'data/actions/analytics';
import { userEmailSelector, userIdSelector } from 'data/selectors/user';

import { LOCAL_STORAGE_KEYS } from 'ts/constants/local-storage-keys';
import type { IAbTest } from 'ts/interfaces/abTest/abTest';

import { getCookie } from './useSignUpQuery';

const useClarity = () => {
  const userId = useSelector(userIdSelector);
  const email = useSelector(userEmailSelector) || '';
  const dispatch = useDispatch();

  useEffect(() => {
    if (window.location.hostname === 'localhost') return;
    clarity.init(process.env.REACT_APP_MICROSOFT_CLARITY_ID || 'p4iufj3yr3');
  }, []);

  useEffect(() => {
    if (userId && clarity.hasStarted()) {
      clarity.identify(userId, { email });
      clarity.setTag('email', email);

      const abTests = localStorage.getItem(LOCAL_STORAGE_KEYS.AB_TESTS)
        ? getJsonFromStorage(LOCAL_STORAGE_KEYS.AB_TESTS)
        : null;
      const clarityCookies = getCookie('_clck');

      if (clarityCookies) {
        const clarityId = clarityCookies.split('|')[0];

        dispatch(
          sendAnalyticEvent({
            event: 'clarity_init',
            data: {
              clarityId
            }
          })
        );
      }

      if (abTests?.length) {
        // set user AB tests tag for clarity
        abTests.forEach((abTest: IAbTest) => {
          if (typeof abTest.variant === 'boolean') {
            return;
          }
          clarity.setTag(abTest.feature, abTest.variant);
        });
      }
    }
  }, [userId, email, dispatch]);
};

export default useClarity;
